/**
 * Limite de projetos abertos vem de `instance.total_projects` (null = sem teto).
 * `open_projects_count` é preenchido no verify_token (taskrush-backend AuthController).
 */
export function isInstanceOpenProjectLimitReached(
  instance?:
    | {
        total_projects?: number | null
        open_projects_count?: number | null
      }
    | null
): boolean {
  if (!instance) return false
  const limit = instance.total_projects
  if (limit == null) return false
  const open = instance.open_projects_count
  if (open == null) return false
  return open >= limit
}

export const INSTANCE_PROJECT_LIMIT_TOOLTIP =
  'Limite de projetos abertos atingido. Feche um projeto existente ou altere o plano para criar novos.'
